export default "__VITE_ASSET__L8FK9ZB___"